<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">商品分类选择</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">

                <el-row class="row">
                    <el-col :span="24" class="item">
                        <div class="label">商品分类</div>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="24" class="item">
                        <el-tree
                            :data="goodsClassList"
                            show-checkbox
                            default-expand-all
                            node-key="goodsClassCode"
                            ref="tree"
                            highlight-current
                            :default-checked-keys="keys"
                            :props="defaultProps">
                        </el-tree>
                    </el-col>
                </el-row>


            </div>

            <div class="modal-footer">
                <el-button type="primary" :loading='loading' @click="confirm()">确定</el-button>
            </div>

        </div>
    </div>
</template>

<script>

    import {getStaffCode} from "@/utils/auth";
    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";


    export default {
        name: 'EditStaff',
        props:['goodsClassList'],
        data() {
            return {
                keys:[],
                edit_serveCode:'',
                edit_name:'',
                listStaffAll:null,
                defaultProps: {
                    label: 'name',
                    children:'secondGoodsClassList'
                },
                loading:false
            }
        },

        methods: {
            init(row){
                this.loading=false
                this.keys=row
                this.getListStaff();
            },

            closeSelf() {
                this.$emit("closeAdd");
            },


            getListStaff(){
                // this.$axios({
                //     method: 'post',
                //     url: this.$shopUrl+"Staff/Business",
                //     data: {
                //         timeStr: timeStr,
                //         sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                //         staffCode: getStaffCode(),
                //         serveCode:this.edit_serveCode,
                //     }
                // }).then(
                //     (response) => {
                //         if (response.data.error == 0) {
                //             this.listStaffAll = response.data.data.staffDTOList;
                //             // this.$refs.tree.setCheckedKeys([response.data.data.staffCode]);
                //         }
                //     }
                // )
            },
            confirm(){
                this.loading=true
                let nodes = this.$refs.tree.getCheckedKeys(false);
                let nodes1 = this.$refs.tree.getHalfCheckedKeys();
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"GoodsClassGovernment/Add",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        goodsClassCodeList: nodes.concat(nodes1),
                    }
                }).then(
                    (response) => {
                        if (response.data.error == 0) {
                            this.loading=false
                            this.$emit("closeAdd");
                            this.$emit("getList");
                        }else if(response.data.error == 1){
                            this.$message.error(response.data.message)
                        }
                    }
                )

            },


        }
    }


</script>


<style lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;

        .modal {
            background-color: #fff;
            box-shadow:  0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
            overflow-x:auto;
            display: flex;
            flex-direction: column;
            border-radius: 10px;
            width: 600px;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .modal-body {
                position: relative;
                padding: 20px 0px;
                z-index: 99;
                overflow-y:auto;
                height: 300px;
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: flex-end;
                padding: 15px;
                display: flex;
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
